import { Dialog as MuiDialog, type DialogProps } from '@mui/material'

/**
 * A dialog that closes when somebody says so, not when they look away.
 *
 * <p>A form clicked outside of used to shut and take everything typed into it
 * with it - a whole quotation, a customer half entered - because that is what a
 * dialog does by default. Nobody clicks the greyed-out page intending to
 * discard their work; they click it because they meant to reach something
 * behind it, or missed.</p>
 *
 * <p>Escape still closes, and so does Cancel. Both are deliberate: one is a key
 * pressed on purpose, the other a button aimed at. A stray click is neither, so
 * it now does nothing.</p>
 */
export function Dialog({ onClose, ...rest }: DialogProps) {
  return (
    <MuiDialog
      {...rest}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return
        onClose?.(event, reason)
      }}
    />
  )
}
